import { FC } from 'react';
import { RangeInput } from 'react-instantsearch-hooks-web';
import { BaseFilter } from './BaseFilter';
import { RangeSlider } from './RangeSlider';

type PriceRangeFilterProps = {
  title: string;
  attribute: string;
  opened: boolean;
};

export const PriceRangeFilter: FC<PriceRangeFilterProps> = ({ title, attribute, opened }) => {
  return (
    <BaseFilter title={title} opened={opened} attribute={attribute}>
      <div className="range-slider-widget range-slider-widget__price">
        <RangeInput attribute={attribute} classNames={{ submit: 'button button--primary' }} />
        <RangeSlider attribute={attribute} />
      </div>
    </BaseFilter>
  );
};
